import React from 'react';
import { Trans } from '@lingui/react';

import { CenteredLayout } from '../tsx.pageLayouts/CenteredLayout';
import { Heading } from '../utils.styles/Heading';
import { html } from '../utils.styles/html';

export function NotFoundPage(props: {}) {
  return (
    <CenteredLayout>
      <Heading system={{ color: 'text_hairline' }}>
        <Trans>
          <html.strong system={{ color: 'primary', fontWeight: 'normal' }}>404</html.strong> | Page
          not found
        </Trans>
      </Heading>
    </CenteredLayout>
  );
}
